import {
    useLayoutEffect, useState
} from 'react';

import { useSelectorCurrentProductId } from '../../app';
import { useSelectorIsInternalUsers } from '../../user-profiles';
import {
    mathleticsTheme,
    internalUsersTheme
} from './theme-variants';

export const useTheme = () => {
    const currentProductId = useSelectorCurrentProductId();
    const isInternalUser = useSelectorIsInternalUsers();
    const [theme, setTheme] = useState(mathleticsTheme);

    useLayoutEffect(() => {
        if (isInternalUser) {
            setTheme(internalUsersTheme);

            return;
        }
    }, [currentProductId, isInternalUser]);

    return { theme };
};
